module.exports = __webpack_public_path__ + "resources/img/img_secure_center01_jp.95432dc8b47049950e50a246fd73474e.png";